export default __webpack_public_path__ + "static/media/back-gray.931562d3.svg";